/**
 * Génère une URL publique vers Supabase Storage.
 * Centralise la dépendance au project ref pour éviter les URLs hardcodées.
 *
 * @param path - Chemin relatif dans le bucket public (ex: "logos/ban.jpg")
 * @returns URL complète vers le fichier dans Supabase Storage
 */
export function getStorageUrl(path: string): string {
  const baseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!baseUrl) {
    throw new Error('VITE_SUPABASE_URL is not defined');
  }
  return `${baseUrl}/storage/v1/object/public/${path}`;
}
